<template>
  <div id="contenedor-tablero-observaciones-auditorias">
    <v-row justify="end">
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-btn
            icon
            v-on="on"
            @click="mixActualizarDatos"
          >
            <v-icon>mdi-reload</v-icon>
          </v-btn>
        </template>
        <span>Actualizar</span>
      </v-tooltip>
      <v-menu
        v-model="mostrarMenuExportar"
        :close-on-content-click="false"
        offset-y>
          <template v-slot:activator="{ on: onMenu }">
          <v-tooltip top>
            <template v-slot:activator="{ on: onTooltip }">
              <v-btn icon
              v-on="{ ...onMenu, ...onTooltip }">
            <v-icon> mdi-export-variant </v-icon>
              </v-btn>
            </template>
            <span>Exportar</span>
          </v-tooltip>
        </template>
        <v-list>
          <ExcelObservaciones
          :auditorias="mixGetAuditorias"
          listItem/>
        </v-list>
      </v-menu>
    </v-row>
    <v-row justify="space-between"
    no-gutters>
        <v-row>
          <template v-for="(tarjeta, index) in mixTarjetas">
            <template>
              <v-card :key="`${tarjeta.titulo}-${index}`"
              class="contenedor-card mt-4 mb-6 mx-2"
              width="31%"
              min-width="300"
              height="150">
                <v-row>
                  <v-col cols="3">
                    <v-alert
                      class="recuadro-flotante"
                      :color="tarjeta.color"
                      align="center"
                      width="100"
                      height="100"
                      elevation="3"
                    >
                      <v-col align="center">
                          <v-row justify="center" >
                            <v-icon color="white" x-large>
                              {{ tarjeta.icono }}
                            </v-icon>
                        </v-row>
                      </v-col>
                    </v-alert>
                  </v-col>
                  <v-col cols="9">
                    <v-card-text class="textos">
                      <v-row justify="end">
                        <span class="titulo body-3 grey--text font-weight-light">
                          {{ tarjeta.titulo }}
                        </span>
                    </v-row>
                    <v-row justify="end">
                        <span class="cantidad font-weight-light">{{ tarjeta.cantidad }}</span>
                    </v-row>
                    <v-row justify="end">
                      <span class="importe font-weight-light">
                        {{ tarjeta.importe | currency }}
                      </span>
                    </v-row>
                    </v-card-text>
                  </v-col>
                </v-row>
              </v-card>
            </template>
          </template>
          <template v-for="(grafica, index) in mixGraficas">
            <template>
              <v-card :key="`${grafica.titulo}-${index}`"
              class="contenedor-card mb-6 mx-2"
              width="31%"
              min-width="300">
                <v-card-title class="mb-0 pb-1 titulo">
                  <v-row justify="center">
                    <span>{{ grafica.titulo }}</span>
                  </v-row>
                </v-card-title>
                <pie-chart
                class="pb-2"
                :width="300"
                :height="200"
                align="center"
                :chart-data="grafica.dataGrafica"
                :options="optionsGrafica">
                </pie-chart>
              </v-card>
            </template>
          </template>
        </v-row>
    </v-row>
    <v-row class="pt-6">
      <v-col cols="12" md="6" sm="12">
        <!-- TABLA RESUMEN DE OBSERVACIONES -->
        <v-card class="contenedor-card">
          <v-row  class="recuadro-flotante-tabla" justify="center">
            <v-alert
            width="90%"
            color="success"
            align="center"
            elevation="3">
            <v-row align="center">
              <v-col align="start" cols="2">
              <v-row justify="center" >
                <v-icon color="white" x-large>
                  mdi-file-document-multiple-outline
                </v-icon>
            </v-row>
          </v-col>
          <v-col>
            <v-row justify="start">
                <span class="titulo white--text">Resumen Por Solventar</span>
            </v-row>
          </v-col>
            </v-row>
          </v-alert>
          </v-row>
          <v-data-table
          class="px-2 recuadro-flotante-tabla"
          disable-filtering
          disable-sort
          hide-default-footer
          :headers="tablaHeaders"
          :items="mixTabla">
          <template
            v-slot:[`item.importe`]="{ item }">
            {{ item.importe | currency }}
          </template>
          <template
            v-slot:[`item.acciones`]="{ item }">
            <v-btn
            icon
            @click="verDetallesObservaciones(item.detalles)">
            <v-icon>
              mdi-information-outline
            </v-icon>
            </v-btn>
          </template>
          </v-data-table>
        </v-card>
        <!-- FIN TABLA RESUMEN DE OBSERVACIONES -->
      </v-col>
      <v-col cols="12" md="6" sm="12">
      <!-- TABLA RESUMEN POR ETIQUETAS -->
      <v-card class="contenedor-card">
          <v-row  class="recuadro-flotante-tabla" justify="center">
            <v-alert
            width="90%"
            color="success"
            align="center"
            elevation="3">
            <v-row align="center">
              <v-col align="start" cols="2">
              <v-row justify="center" >
                <v-icon color="white" x-large>
                  mdi-label-outline
                </v-icon>
            </v-row>
          </v-col>
          <v-col>
            <v-row justify="start">
                <span class="titulo white--text">Resumen Por Etiquetas</span>
            </v-row>
          </v-col>
            </v-row>
          </v-alert>
          </v-row>
          <v-data-table
          class="px-2 recuadro-flotante-tabla"
          disable-filtering
          disable-sort
          hide-default-footer
          :headers="tablaEtiquetasHeaders"
          :items="mixGetDetallesPorEtiqueta">
          <template
            v-slot:[`item.descripcion`]="{ item }">
            <v-chip
              @click="eliminarEtiqueta(etiqueta, detalle)"
              small
              class="ml-2"
              :color="item.color"
              :dark="item.esTextoClaro"
            >
              {{ item.descripcion }}
            </v-chip>
          </template>
          <template
            v-slot:[`item.acciones`]="{ item }">
            <v-btn
            icon
            @click="verDetallesObservaciones(item.detalles)">
            <v-icon>
              mdi-information-outline
            </v-icon>
            </v-btn>
          </template>
          </v-data-table>
          <!-- BOTON EXPORTAR EXCEL -->
          <v-row class="pt-0 pb-4 my-0" justify="center">
            <ExcelObservacionesAuditoriasEtiquetas
            :etiquetasConDesgloses="mixGetDetallesPorEtiqueta" />
          </v-row>
        </v-card>
        <!-- FIN TABLA RESUMEN POR ETIQUETAS -->
      </v-col>
    </v-row>
    <v-dialog
    v-if="estosDetalles"
    v-model="mostrarListadoDetallesObservaciones"
    width="90%"
    scrollable>
      <v-card>
        <v-card-title class="secondary--text">
          Detalles
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrarVentanaDetalles">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <ListadoDetallesObservaciones
            :detalles="estosDetalles"
            v-on:cerrar="cerrarVentanaDetalles"
          />
        </v-card-text>
        <v-card-actions>
          <v-row justify="center">
            <custom-button
            @click="cerrarVentanaDetalles"
            tipo="formCancelar"
            label="Cerrar"
            class="mr-3">
            </custom-button>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import mixTablerosObservaciones from './mixTablerosObservaciones';
import ListadoDetallesObservaciones from './ListadoDetallesObservaciones.vue';
import ExcelObservaciones from '@/components/exportar/exceles/ExcelObservacionesAuditorias.vue';
import ExcelObservacionesAuditoriasEtiquetas from '@/components/exportar/exceles/ExcelObservacionesAuditoriasEtiquetas.vue';
import CustomButton from '@/components/buttons/Button.vue';
import PieChart from '@/components/charts/PieChart';

export default {
  name: 'TableroObservacionesAuditorias',
  mixins: [mixTablerosObservaciones],
  props: {
    filtros: {
      type: Object,
      required: true,
    },
  },
  components: {
    PieChart,
    ListadoDetallesObservaciones,
    ExcelObservacionesAuditoriasEtiquetas,
    ExcelObservaciones,
    CustomButton,
  },
  data() {
    return {
      mostrarMenuExportar: false,
      mostrarListadoDetallesObservaciones: false,
      estosDetalles: null,
      optionsGrafica: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          position: 'bottom', // Coloca los labels en la parte inferior
          labels: {
            usePointStyle: true, // Usar puntos en lugar de cajas de color
            padding: 20, // Aumentar el espaciado entre los elementos de la leyenda
          },
        },
      },
      tablaEtiquetasHeaders: [
        {
          text: 'Etiqueta',
          align: 'start',
          value: 'descripcion',
        },
        {
          text: 'Cantidad',
          align: 'center',
          value: 'detalles.length',
        },
        {
          text: 'Detalles',
          align: 'center',
          value: 'acciones',
        },
      ],
      tablaHeaders: [
        {
          text: 'Estatus',
          align: 'start',
          value: 'titulo',
        },
        {
          text: 'Cantidad',
          align: 'center',
          value: 'cantidad',
        },
        {
          text: 'Importe',
          align: 'center',
          value: 'importe',
        },
        {
          text: 'Detalles',
          align: 'center',
          value: 'acciones',
        },
      ],
    };
  },
  methods: {
    cerrarVentanaDetalles() {
      this.mostrarListadoDetallesObservaciones = false;
      this.estosDetalles = null;
    },
    verDetallesObservaciones(detalles) {
      this.estosDetalles = detalles;
      this.mostrarListadoDetallesObservaciones = true;
    },
  },
};
</script>

<style lang="scss" scoped>

.titulo {
  font-size: 20px;
  line-height: normal;
  text-align: end;
  color: #555;
  letter-spacing: 0.5px;
}
.cantidad {
  font-size: 35px;
  text-align: end;
  line-height: normal;
  margin-top: 5px;
  color: #555;

}
.importe {
  font-size: 25px;
  text-align: end;
  line-height: normal;
  margin-top: 5px;
  color: #555;
}
.textos {
  position: relative !important;
  top: -20px;
}
.contenedor-card {
  transition: all 0.3s ease;
  position: relative !important;
  top: 20px;
}
.contenedor-card:hover {
      transform: translateY(-5px);
      box-shadow: 0 5px 5px rgba(0, 0, 0, 0.2);
    }
.recuadro-flotante {
  position: relative !important;
  top: -30px;
  left: 5px;
}
.recuadro-flotante-tabla {
  position: relative !important;
  top: -30px;
}
</style>
